// Validator module
!function(name, module, context){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('hotels/validators',['libs/ct_pers', 'common/validators'], module)
	else
	//>>excludeEnd("requireTmpl"); 
		context[name] = module(CT.Pers, CT.settings.validators)
}('validators', function(Pers, commonValidators){

	var Validators = $.extend(commonValidators, {

		shortListHotels : function(dataHash){
			var pers = new Pers() // TODO check the speed of this process
			var shortListHotels = (typeof pers.get('shortlisted') != "undefined") ? (pers.get('shortlisted')[0]) : '';
			if (shortListHotels){
				if(dataHash.chk_in !== '' && dataHash.chk_out !== '') {
					var cid = moment(dataHash.chk_in).format("DD/MM/YY");
					var cod = moment(dataHash.chk_out).format("DD/MM/YY");
					var city = shortListHotels[dataHash.city]
					var hList = '';
					if ( typeof city !== 'undefined' && (typeof city[cid + "-" + cod] !== 'undefined'))
						hList = city[cid + "-" + cod].join("-");
					dataHash.shortListed = hList
				}
			}
		},


		checkAvail : function(dataHash){
			if(dataHash.checkAvail) dataHash.replace = true
		}
	
	})


	return Validators

}, CT.settings)


;
